import React from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';
/* Contexts */
import { AuthProvider } from './context/AuthContext';
import { HttpProvider } from './context/HttpContext';
import AppRoutes from './AppRoutes';
import Maintenance from './pages/Maintenance';

function App() {
  // Maintenance mode: when on, show only the message (login disabled) for anyone
  // who loads or refreshes the portal. Toggled by REACT_APP_MAINTENANCE at build time.
  if (process.env.REACT_APP_MAINTENANCE === 'true') {
    return <Maintenance />;
  }

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
      <AuthProvider>
        <HttpProvider>
          <AppRoutes />
        </HttpProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}
export default App;
